
import { Component, Vue } from "vue-property-decorator";

export default class NewLogin extends Vue {}
